import TextBox from "devextreme-react/text-box";
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { emailApi } from '../../api/emailApi';
import { DefaultButton, PrimaryButton } from '../../components/editor/button';
import { useCommonContext } from '../../contexts/common';
import { showNotify } from '../../helpers/toast';
import SelectBoxEmailTemplate from "../../components/editor/cb_email_template";
import SelectUserPheDuyet from '../../components/editor/selectbox_user_pheduyet';
import SelectBoxEmail from '../../components/editor/selectbox_email';

const DotGuiDetailModal = ({ id, onSuccess, onCancel, username }) => {
    const { translate } = useCommonContext();
    const { dm_coso_id } = useSelector((x) => x.coSo);
    const [isSendPheDuyet, setIsSendPheDuyet] = useState(false);
    const [isDaSendPheDuyet, setDaIsSendPheDuyet] = useState(false);
    const [formData, setFormData] = useState({
        id: id,
        ts_email_template_id: 0,
        subject: '',
        body: '',
        dm_trangthai_email_id: 1,
        total_user: 0,
        total_success: 0,
        total_fail: 0,
        send_schedule: null,
        dm_cauhinhemail_id: 0,
        user_id_pheduyet: 0,
        user_id_daduyet: 0,
        user_id_ngayduyet: null,
        dm_coso_id: dm_coso_id,
        send_ketqua_ts: false,
        selectedRowKeys: []
    });
    const [isSaving, setIsSaving] = useState(false);
    const { trigger, errors } = useForm();
    const handleSaveAndSendPheDuyetChanges = async () => {
        setIsSendPheDuyet(true)
    };
    useEffect(() => {
        if (isSendPheDuyet) {
            handleSaveChanges();
        }
    }, [isSendPheDuyet]);
    const handleSaveChanges = async () => {
        trigger().then(async (isValid) => {
            if (isValid) {
                if (formData.ts_email_template_id == 0) {
                    showNotify({ text: 'Vui lòng chọn theo mẫu email', type: 'error' });
                    return;
                }
                if (formData.subject == '') {
                    showNotify({ text: 'Vui lòng nhập tiêu đề email', type: 'error' });
                    return;
                }
                // if (formData.user_id_pheduyet == 0) {
                //     showNotify({ text: 'Vui lòng chọn người phê duyệt', type: 'error' });
                //     return;
                // }
                if (formData.id > 0) {
                    setIsSaving(true);
                    const datasend = { ts_email: formData, isSendPheDuyet: isSendPheDuyet }
                    const res = await emailApi.Update(datasend);
                    setIsSaving(false);
                    if (res.is_success) {
                        showNotify({ text: translate('Cập nhật thành công '), type: 'success' });
                        onSuccess();
                    } else {
                        showNotify({ text: res.message, type: 'error' });
                    }

                } else {
                    setIsSaving(true);
                    const datasend = { ts_email: formData, isSendPheDuyet: isSendPheDuyet }
                    const res = await emailApi.Insert(datasend);
                    setIsSaving(false);
                    if (res.is_success) {
                        showNotify({ text: translate('Lưu thành công '), type: 'success' });
                        onSuccess();
                    } else {
                        showNotify({ text: res.message, type: 'error' });
                    }
                }
            }
        });
    };
    const handleGetDetail = useCallback(async () => {
        if (id > 0) {
            const res = await emailApi.SelectById(id);
            if (res.is_success) {
                const data = res.data;
                if (data) {
                    if (data.user_id_daduyet > 0) {
                        setDaIsSendPheDuyet(true)
                    }
                    setFormData((prev) => ({
                        ...prev,
                        id: data.id,
                        ts_email_template_id: data.ts_email_template_id,
                        subject: data.subject,
                        body: data.body,
                        dm_trangthai_email_id: data.dm_trangthai_email_id,
                        dm_cauhinhemail_id: data.dm_cauhinhemail_id,
                        user_id_pheduyet: data.user_id_pheduyet,
                        dm_coso_id: dm_coso_id,
                        send_ketqua_ts: false
                    }));
                }
            }
        }
    }, [id]);
    useEffect(() => {
        handleGetDetail();
    }, [id]);
    return (
        <div>
            <Modal
                open={true}
                size='small'
                dimmer={'blurring'}
                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>{formData.id > 0 ? <p>{translate('Cập nhật')}</p> : <p>{translate('Tạo đợt gửi mới')}</p>}</Modal.Header>
                <Modal.Content>
                    <form className='ui'>
                        <input className='hide' name='id' defaultValue={formData.id}></input>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='dx-field-label'>{translate('Tiêu đề gửi email')}</div>
                                <br></br>
                                <TextBox
                                    stylingMode='outlined'
                                    onValueChanged={(e) => {
                                        setFormData((prev) => ({ ...prev, subject: e.value }));

                                    }}
                                    readOnly={formData.dm_trangthai_email_id > 1}
                                    value={formData.subject}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 padding-top-1rem'>
                                <div className='dx-field-label'>{translate('Gửi từ email')}</div>
                                <br></br>
                                <SelectBoxEmail
                                    onValueChanged={(value) => {
                                        setFormData((prev) => ({ ...prev, dm_cauhinhemail_id: value }));

                                    }}
                                    value={formData.dm_cauhinhemail_id}
                                    user={username}
                                    showClearButton={true}
                                    disabled={formData.dm_trangthai_email_id > 1}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 padding-top-1rem'>
                                <div className='dx-field-label'>{translate('Người phê duyệt')}</div>
                                <br></br>
                                <SelectUserPheDuyet
                                    dm_coso_id1={dm_coso_id}
                                    onValueChanged={(value) => {
                                        setFormData((prev) => ({ ...prev, user_id_pheduyet: value }));
                                    }}
                                    value={formData.user_id_pheduyet}
                                    showClearButton={true}
                                    disabled={formData.dm_trangthai_email_id > 1}

                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 padding-top-1rem'>
                                <div className='dx-field-label'>{translate('Mẫu email')}</div>
                                <br></br>
                                <SelectBoxEmailTemplate
                                    dm_coso_id={dm_coso_id}
                                    onValueChanged={(value) => {
                                        setFormData((prev) => ({ ...prev, ts_email_template_id: value }));

                                    }}
                                    value={formData.ts_email_template_id}
                                    showClearButton={true}
                                    disabled={formData.dm_trangthai_email_id > 1}

                                />
                            </div>
                        </div>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text={'Đóng'} onClick={onCancel} />
                        <PrimaryButton text={'Lưu'} disabled={formData.dm_trangthai_email_id > 1} onClick={handleSaveChanges} isLoading={isSaving} />
                        < PrimaryButton disabled={isDaSendPheDuyet} text={'Lưu & Gửi phê duyệt'} onClick={handleSaveAndSendPheDuyetChanges} isLoading={isSaving} />

                    </div>
                </Modal.Actions>
            </Modal>
        </div>
    );
};
export default DotGuiDetailModal;
